<!--
  NylonStepMarker — vetted Nylon step-progress marker.

  A numbered circle for a multi-step flow's progress nav (the submission
  wizard's step row). Three presentations driven by two booleans:

    - resting / upcoming (default) — translucent ring, white number.
    - active                       — current step, enlarged with a glow.
    - clickable                    — a navigable (already-visited) step;
                                     pointer cursor + grows on hover, easing
                                     back to resting on release.

  The number (or any label) is the default slot. Designed against a dark /
  red surface — give it a dark background (the wizard header does).

  Click handling: a `@click` listener on the tag falls through to the root
  element, so consumers wire navigation directly:

    <NylonStepMarker :active="..." :clickable="..." @click="goToStep(n)">1</NylonStepMarker>

  Visual styling lives in
  resources/assets/scss/nylon/components/_NylonStepMarker.scss.

  Props:
    active    (Boolean) — current step. Default false.
    clickable (Boolean) — navigable previous step. Default false.

  Slots:
    default            — the marker's content (typically a step number).
-->
<template>
  <span
    class="nylon-StepMarker"
    :class="{
      'nylon-StepMarker--active': active,
      'nylon-StepMarker--clickable': clickable,
    }"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: "NylonStepMarker",

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
